module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2015/desktop_old.svg?v=afc095b7";